import React, { FunctionComponent } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';
import * as styles from '../../productPage/tableComponents/ProductPage_style';
import { GetResponsiveWidth } from '../../common/TabsComponent';
import { useResponsive } from '../../../contexts/ResponsiveContext';
import { buttonStyleProps } from '../../yageoGroupPage/YageoGroupOverviewPage';
import { useSalesAndResourcesSimulationToolsContent } from '../../../graphql/pimcore/modules/siteContent/hooks/useSalesAndResourcesSimulationToolsContent';
import BreadCrumbs from '../../common/BreadCrumbs';
import OutterWrapper from '@/components/common/OutterWrapper';

interface FITCalculatorProps {}

const FITCalculatorPage: FunctionComponent<FITCalculatorProps> = () => {
    const { isScreenMd, isScreenSm, isScreenXs } = useResponsive();
    const { contentTree } = useSalesAndResourcesSimulationToolsContent();

    const location = useLocation();

    const cardData = [
        {
            title: contentTree.Overview.FITCalculator.Software.title.content,
            description: contentTree.Overview.FITCalculator.Software.subtitle.content,
            buttonText: contentTree.Overview.FITCalculator.Software.linkButton.linkText,
            imgSrc: contentTree.Overview.FITCalculator.Software.backgroundImage.imageUrl,
            link: contentTree.Overview.FITCalculator.Software.linkButton.linkUrl,
        },
        {
            title: contentTree.Overview.FITCalculator.Manual.title.content,
            description: contentTree.Overview.FITCalculator.Manual.subtitle.content,
            buttonText: contentTree.Overview.FITCalculator.Manual.linkButton.linkText,
            imgSrc: contentTree.Overview.FITCalculator.Manual.backgroundImage.imageUrl,
            link: contentTree.Overview.FITCalculator.Manual.linkButton.linkUrl,
        },
    ];

    return (
        <OutterWrapper
            componentName={'FIT'}
            pathname={location.pathname}
            pageTitle={contentTree.Overview.FITCalculator.pageTitle.content}
            pagesubTitle={contentTree.Overview.FITCalculator.pageSubtitle.content}
            bannerImageUrl={contentTree.Overview.FITCalculator.pageTitleBackgroundImage.imageUrl}
            breadcrumbsComponent={
                <BreadCrumbs navigationPath="/Home/SalesAndResources/SimulationTools/FailureInTimeCalculator" />
            }
        >
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    paddingTop: '1rem',
                    paddingBottom: '2rem',
                    flexDirection: isScreenSm || isScreenXs ? 'column' : 'row',
                    overflowY: 'hidden',
                    backgroundColor: 'white',
                    width: GetResponsiveWidth,
                    alignItems: 'flex-start',
                    margin: 'auto',
                    gap: '1rem',
                }}
            >
                {cardData.map((card, index) => (
                    <Box
                        key={index}
                        sx={{
                            marginTop: '1.5rem',
                            marginBottom: isScreenSm || isScreenXs ? 0 : '1.5rem',
                            position: 'relative',
                            width: isScreenSm || isScreenXs ? '100%' : '577.5px',
                            height: '440px',
                            overflow: 'hidden',
                        }}
                    >
                        {/* gray layer */}
                        <img
                            src={card.imgSrc}
                            alt={card.title}
                            style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                                filter: 'grayscale(100%)',
                            }}
                        />

                        {/* content */}
                        <Box
                            sx={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                                textAlign: 'center',
                                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                color: 'white',
                                padding: isScreenSm || isScreenXs || isScreenMd ? '2rem' : '5rem',
                            }}
                        >
                            <Typography sx={{ fontWeight: 700, fontSize: '28px' }}>
                                {card.title}
                            </Typography>
                            <Typography
                                sx={{ marginTop: '0.5rem', fontWeight: 400, fontSize: '16px' }}
                            >
                                {card.description}
                            </Typography>
                            <Button
                                variant="contained"
                                sx={{
                                    marginTop: '1.5rem',
                                    ...buttonStyleProps,
                                }}
                                onClick={() => window.open(card.link)}
                            >
                                {card.buttonText}
                            </Button>
                        </Box>
                    </Box>
                ))}
            </Box>
        </OutterWrapper>
    );
};

export default FITCalculatorPage;
